<template>
  <div class='EnbLikes'>
    <div class="cont-itens">
      <div class="label">Meus Favotiros</div>
      <enb-checkoutItem01
      v-for="(data, key) in likes"
      :key="key"
      :data="data"
      @DelLike="NewValue => Del(NewValue)"
      />
    </div>
  </div>
</template>

<script>
import EnbCheckoutItem01 from './EnbCheckoutItem01'
export default {
  name: 'EnbLikes',
  components: { EnbCheckoutItem01 },
  data () {
    return {
      likes: []
    }
  },
  created () {
    let likes = JSON.parse(localStorage.getItem('likes'))
    if(likes) {
      this.likes = likes
    }
    else {
      this.likes = []
    }
  },
  methods: {
    Del (prod) {
      let likes = this.likes.filter(i => i.id !== prod.id)
      this.likes = likes
      localStorage.setItem('likes', JSON.stringify(this.likes))
    }
  }
}
</script>

<style scoped>
.EnbLikes {
  width: 80%;
  margin: auto;
  overflow: auto;
}

.cont-itens {
  width: 100%;
}

.label {
  width: 80%;
  text-align: left;
  font-size: 22px;
  font-weight: bold;
  padding: 2%;
}

@media (max-width: 500px) {
  .EnbLikes {
    width: 95%;
  }
  .label {
    padding-bottom: 5%;
  }
}
</style>
